import Dialog from "@material-ui/core/Dialog";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import {
	Theme,
	WithStyles,
	createStyles,
	withStyles,
} from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React, { ReactNode } from "react";
import { ModalTabTitle } from "../title/modal-tab-title";

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: theme.spacing(1),
			color: theme.palette.grey[500],
		},
	});

export interface DialogTitleProps extends WithStyles<typeof styles> {
	id: string;
	children: React.ReactNode;
	onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			) : (
				<></>
			)}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles((theme: Theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(1),
	},
}))(MuiDialogActions);

interface MESFModalProps {
	handleClose: (shouldUpdate?: boolean) => void;
	open: boolean;
	id?: string;
	maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
	children: ReactNode;
	title?: JSX.Element | string;
	helmetSuffix?: string;
	disableEnforcedFocus?: boolean;
}

function Modal({
	children,
	title,
	handleClose,
	open,
	id = "mesf-modal",
	maxWidth = "lg",
	helmetSuffix,
	disableEnforcedFocus = true,
}: MESFModalProps) {
	return (
		<>
			<ModalTabTitle
				open={open}
				helmetSuffix={helmetSuffix}
				title={typeof title === "string" ? title : undefined}
			/>
			<Dialog
				onClose={() => handleClose()}
				aria-labelledby={id}
				open={open}
				maxWidth={maxWidth}
				fullWidth
				disableEnforceFocus={disableEnforcedFocus}
			>
				<DialogTitle id={id} onClose={() => handleClose()}>
					{title}
				</DialogTitle>
				{children}
			</Dialog>
		</>
	);
}

export default Object.assign(Modal, {
	Content: DialogContent,
	Actions: DialogActions,
});
